const replaceLastInstance = (value: string, searchValue: string, replaceValue: string): string => {
	const lastIndex = value.lastIndexOf(searchValue);
	if (lastIndex >= 0) {
		return value.slice(0, lastIndex) + replaceValue + value.slice(lastIndex + 1);
	}
	return value;
};

export const adoptOrphans = (value: string, maxToAdopt = 1): string => {
	let result = value;
	for (let numSpacesReplaced = 0; numSpacesReplaced < maxToAdopt; numSpacesReplaced += 1) {
		result = replaceLastInstance(result, ' ', '\u00a0');
	}
	return result;
};
